export default "__VITE_ASSET__CLGPUDPn__"